import { render } from "./EntraLicences.vue?vue&type=template&id=23c444c2&scoped=true"
import script from "./EntraLicences.vue?vue&type=script&lang=js"
export * from "./EntraLicences.vue?vue&type=script&lang=js"

import "./EntraLicences.vue?vue&type=style&index=0&id=23c444c2&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c444c2"]])

export default __exports__